import * as React from 'react'

import getConfig from 'next/config'

import { RouteConfigs } from '@grandvisionhq/frk-routing'
import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/frames'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { commonSpecifications, getDeliveryIndicatorConfig } from '../../../configuration'

const { publicRuntimeConfig } = getConfig()
const defaultAppointmentTypeId = publicRuntimeConfig.opco?.defaultAppointmentTypeIdPDP

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()
  const pdpRoute: RouteConfigs | undefined = defaultAppointmentTypeId
    ? {
        route: 'appointments.book',
        query: new URLSearchParams({ typeId: defaultAppointmentTypeId }),
      }
    : undefined

  return (
    <Page
      {...props}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
      specificationConfiguration={commonSpecifications}
      bookAppointmentRouteConfig={pdpRoute}
    />
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps
export default composePDP<Props>(ProductDetailPage)
